module.exports = "<div class=\"prices\">\n\t<div class=\"container\">\n\t\t<h2>Árak</h2>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prices/prices.component.html
// module id = ./src/app/prices/prices.component.html
// module chunks = 1